__turbopack_context__.v({
  "color": "PfCnKq_color",
  "colorButton": "PfCnKq_colorButton",
  "selected": "PfCnKq_selected",
});
